import { __assign } from "tslib";
import React, { Suspense } from 'react';
var loading = function () {
    return React.createElement("div", { className: "animated fadeIn pt-1 text-center" }, "Loading...");
};
var BootStrapSkeleton = React.lazy(function () {
    return import('../../bootstrap-components/components/BTSkeleton');
});
var bootStrapSkeleton = function (props) {
    return (React.createElement(BootStrapSkeleton, __assign({}, props)));
};
export var Skeletons = function (props) {
    var componentToDisplay = bootStrapSkeleton(props);
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading() }, componentToDisplay)));
};
export default Skeletons;
//# sourceMappingURL=Skeleton.js.map